import { render, staticRenderFns } from "./content-game-info.vue?vue&type=template&id=a9c95c00&scoped=true&"
import script from "./content-game-info.vue?vue&type=script&lang=js&"
export * from "./content-game-info.vue?vue&type=script&lang=js&"
import style0 from "./content-game-info.vue?vue&type=style&index=0&id=a9c95c00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c95c00",
  null
  
)

export default component.exports